import React, { useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useParams,
  useRouteMatch,
  Navigate,
  Outlet,
} from 'react-router-dom';
import { useRoutes } from 'react-router-dom';
import { AllPages } from 'app/routes/routes';
// import Notes from './pages/Notes';
import Create from '../pages/ninja/Create';
// import EgatRegist from '../pages/ninja/egatRegist/App1';
// import FormSubmit from '../pages/ninja/egatRegist/App2';
import VerticalTabs from '../pages/ninja/VerticalTab';
// import Matx1 from '../pages/ninja/egatRegist/Matx1';
// import Notes from '../pages/ninja/Notes';
import AppAutoComplete from '../pages/matx/components/AppAutoComplete';
import { StyledEngineProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { blue, purple } from '@mui/material/colors';
import Layout from './NinjaLayout';
import Home from './Home';
import NotFound from 'app/views/sessions/NotFound';
import { useSelector } from 'react-redux';
import AutocompleteCombo from '../pages/matx/components/AutocompleteCombo';
import CustomerForm from 'app/views/pages/customers/customer-form/CustomerForm';
import PersonalInformation from 'app/views/forms/PersonalInformation';
import Stepper1 from 'pages/stepper1/Stepper1';
import Stepper2 from 'pages/stepper2/Stepper2';
import Stepper3 from 'pages/stepper3/Stepper3';
import Stepper4 from 'pages/stepper4/Stepper4';
import Stepper4_2 from 'pages/stepper4/Stepper4_2';
import Stepper4HrInspect from 'pages/stepper4/Stepper4HrInspect';
import EmploymentPage from 'pages/stepper4/components/EmploymentPage/EmploymentPageTest1';
import EmploymentPage221116 from 'pages/stepper4/components/EmploymentPage/Forms/PersonalForm_221116';
import HrInspection from 'pages/stepper4/components/EmploymentPage/HrInspection';
import HrInspectionReport from 'pages/stepper4/components/EmploymentPage/HrInspectionReport';
import R3Frame from 'pages/stepper4/components/reports/R3Frame';
import R4Frame from 'pages/stepper4/components/reports/R4Frame';
import R1Frame from 'pages/stepper4/components/reports/R1Frame';
import EmploymentPageHrInspection from 'pages/stepper4/components/EmploymentPage/EmploymentPageHrInspection';
// import CustomerForm from '../app/views/pages/customers/customer-form/CustomerForm';

// from App.js

const theme = createTheme({
  palette: {
    // primary: {
    //   main: '#fefefe',
    // },
    // secondary: purple,
    secondary: blue,
  },
  typography: {
    fontFamily: 'Sarabun',
    fontWeightLight: 300,
    fontWeightRegular: 500,
    fontWeightMedium: 600,
    fontWeightBold: 700,
  },
});

// function NotFound() {
//   return (
//     <div style={{ textAlign: 'center', padding: '50px' }}>
//       <h1>404</h1>
//       <h2>Page Not Found</h2>
//       <p>The page you're looking for doesn't exist.</p>
//       <Link to="/">Go back home</Link>
//     </div>
//   );
// }

//from App.js
function Example() {
  // const [count, setCount] = useState(0);
  // let { path, url } = useRouteMatch();

  const all_pages = useRoutes(AllPages());

  const { user: currentUser } = useSelector((state) => state.auth);
  if (!currentUser) {
    return <Navigate to="/app/login" />;
  }

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div>
          <Layout>
            {all_pages}
            <Routes>
              {/* <Route path="/" element={<Home />} /> */}
              {/* <Route path="/home" element={<Home />} /> */}
              {/* <Route path={`/back-to-user`} element={<Home />} /> */}
              {/* <Route path={`/ninja-notes`}><Notes /></Route> */}
              {/* <Route path={`/ninja-create`} element={<Create />} /> */}
              {/* <Route path={`/ninja-egat-regist`}><EgatRegist /></Route> */}
              {/* <Route path={`/ninja-form-submit`}><FormSubmit /></Route> */}
              <Route path={`/ninja-egat-tabs`} element={<AppAutoComplete />} />
              <Route path="/home" element={<Home />} />
              {/* <Route path="*" element={<NotFound />} /> */}
              <Route
                path="/ninja-egat-customer-form"
                element={<CustomerForm />}
              />
              <Route
                path="/property-listing-form"
                element={<PersonalInformation />}
              />
              <Route path="/stepper1" element={<Stepper1 />} />
              <Route path="/stepper2" element={<Stepper2 />} />
              <Route path="/stepper3" element={<Stepper3 />} />
              <Route path="/employment-form" element={<Stepper4 />} />
              <Route
                path="/employment-form-test1"
                element={<EmploymentPage />}
              />
              <Route path="/employment-form-test2" element={<Stepper4_2 />} />
              <Route path="/hr-inspection" element={<HrInspection />} />
              <Route
                path="/hr-inspection-emp/:idCard"
                element={<Stepper4HrInspect />}
              />
              <Route
                path="/hr-inspection-report"
                element={<HrInspectionReport />}
              />
              {/* Catch-all route for 404 - must be last */}
              {/* <Route path="*" element={<NotFound />} /> */}
              {/* <Route path="/hr-inspection-report1" element={<R1Frame />} /> */}
              {/* <Route path="/hr-inspection-report3" element={<R4Frame />} /> */}
              {/* <Route path={`/matx1`}><VerticalTabs /></Route> */}
            </Routes>
          </Layout>
        </div>
      </ThemeProvider>
    </StyledEngineProvider>
    // <div>
    //   <p>You clicked {count} times</p>
    //   <button onClick={() => setCount(count + 1)}>
    //    Click me
    //   </button>
    // </div>
  );
}

export default Example;
